import { render, staticRenderFns } from "./materialsDialog.vue?vue&type=template&id=112810b8&scoped=true"
import script from "./materialsDialog.vue?vue&type=script&lang=js"
export * from "./materialsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112810b8",
  null
  
)

export default component.exports